












































































































































































































































































































































































































































import Listicon from '@/assets/img/clinicListicon.svg';
import { config } from '@/common/app.config';
import PopupConfirm from '@/components/common/PopupConfirm.vue';
import PopupConfirmDeletion from '@/components/common/PopupConfirmDeletion.vue';
import { ClinicModule } from '@/store';
import { CType, Roles } from '@common/app.config';
import Toast from '@common/helpers/toast';
import ClinicsMixin from '@common/mixins/Clinic/ClinicsMixin';
import ContentLayout from '@components/layouts/Content.vue';
import { dom, library } from '@fortawesome/fontawesome-svg-core';
import {
  faCameraRetro,
  faDownload,
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';
import ApiHelper from 'api-helper';
import { canEditClinicName } from '@common/helpers/clinic-permission';
import { get } from 'lodash';
import { extend } from 'vee-validate';
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import PageLoader from '@components/common/PageLoader.vue';
import ToggleSwitch from '@/components/common/ToggleSwitch.vue';

@Component({
  head: {
    title: {
      inner: 'クリニック詳細・編集',
    },
  },
  components: {
    PopupConfirm,
    PopupConfirmDeletion,
    ContentLayout,
    PageLoader,
    ToggleSwitch,
  },
  computed: {
    ...mapState('auth', ['currentUser']),
  },
  data() {
    return {
      clinicId: this.$route.params.clinicId,
      prefectures: [],
      cities: [],
      clinic: {},
      iconHeader: Listicon,
      appConfig: config,
    };
  },
})
export default class ClinicInfo extends Mixins(ClinicsMixin) {
  public iconHeader: any;
  public appConfig: any;
  public listPrefecture: any[] = [];
  public extend: any = extend;
  public typeValidate: string = 'input';
  public isSubmiting = false;
  public isSubmitDelete: boolean = false;
  public currentUser: any;
  public clinicId!: any;
  public clinicUuid: string = '';
  public isSetPrefectureCity: boolean = false;
  public isChange: boolean = false;
  public CType = CType;
  public isLoading: boolean = false;

  public updateClinicForm = {
    name: '',
    name_kana: '',
    phone: '',
    postal_code: '',
    prefecture_id: '',
    city_id: '',
    address: '',
    building_name: '',
    type: '',
    gtm_id: '',
    template: '',
    title_lp: '',
    description_lp: '',
    telemedicine_enabled: false,
    custom_field_enabled: false,
    custom_field_label: '',
    custom_field_required: false,
  };

  public get listPrefectureOption() {
    return this.listPrefecture.map((prefecture) => {
      return {
        title: prefecture.ja_name,
        id: `${prefecture.id}`,
      };
    });
  }

  public get listTypeOption() {
    return [
      { title: 'クリニック', id: `clinic` },
      { title: 'サロン', id: `salon` },
      { title: '診察クリニック', id: `clinic_doctor` },
    ];
  }

  goToLpSetting() {
    this.$router.push({
      path: `/clinics/show/${this.clinicId}/lp-setting`,
      query: {
        id: this.$route.query.id || '',
        name: this.$route.query.name || '',
        clinic_name: this.$route.query.name_kana || '',
        page: this.$route.query.page?.toString() || '1',
      },
    });
  }

  public openCancelCreateClinic() {
    return this.$router.push({
      name: 'clinics',
      query: {
        id: this.$route.query.id || '',
        name: this.$route.query.name || '',
        name_kana: this.$route.query.name_kana || '',
        page: this.$route.query.page ? this.$route.query.page.toString() : '1',
      },
    });
  }

  public handleToggleSwitchChange(checked, validate) {
    this.$set(this.updateClinicForm, 'telemedicine_enabled', checked);
    validate(this.updateClinicForm.telemedicine_enabled);
  }

  public handleCustomFieldEnabledChange(checked, validate) {
    this.$set(this.updateClinicForm, 'custom_field_enabled', checked);
    validate(this.updateClinicForm.custom_field_enabled);
  }

  public handleCustomFieldRequiredChange(checked, validate) {
    this.$set(this.updateClinicForm, 'custom_field_required', checked);
    validate(this.updateClinicForm.custom_field_required);
  }

  public get computedForm() {
    return this.$refs.updateClinicForm as any;
  }

  public get canEditClinicName() {
    return canEditClinicName(this.currentUser);
  }

  public updateIsSubmiting(isSubmiting: boolean) {
    this.isSubmiting = isSubmiting;
  }

  public updateIsChange(isChange: boolean) {
    if (this.isChange && isChange) {
      return;
    }
    this.isChange = isChange;
  }

  public input() {
    return {
      on: ['input'],
    };
  }

  @Watch('updateClinicForm', { deep: true })
  public formChangeData() {
    !this.isChange && this.updateIsChange(true);
  }

  public async updateInfoClinic() {
    try {
      // const re = /^0/gi;
      const cpForm = Object.assign({}, this.updateClinicForm);
      // cpForm.phone = cpForm.phone && cpForm.phone.replace(re, '81');
      // cpForm.fax = cpForm.fax && cpForm.fax.replace(re, '81');
      // cpForm.manager_phone = cpForm.manager_phone && cpForm.manager_phone.replace(re, '81');
      this.updateIsSubmiting(true);
      await ApiHelper.getApi('ClinicApi').update(this.clinicId, cpForm);
      this.updateIsSubmiting(false);
      this.updateIsChange(false);
      Toast.success('更新しました');
      const data = await ClinicModule.getClinicDetail(this.clinicId);
      if (this.currentUser.role === Roles.clinic) {
        const updateData = { ...this.currentUser, clinics: [data] };
        await this.$store.dispatch('auth/updateUser', updateData);
      }
    } catch (error) {
      this.updateIsSubmiting(false);
      this.updateIsChange(false);
      const data = error.response.data;
      Toast.error(data.message);
      if (error.response.status === 422) {
        this.computedForm.setErrors(error.response.data.errors);
        return;
      }
    }
  }

  public async deleteInfoClinic() {
    try {
      this.isSubmitDelete = true;
      await ApiHelper.getApi('ClinicApi').delete(this.clinicId);
      this.isSubmitDelete = false;
      Toast.success('削除しました');
      this.$router.push('/clinics');
    } catch (error) {
      this.isSubmitDelete = false;
      const data = error && error.response.data;
      if (error.response && error.response.status === 422) {
        return;
      }
      Toast.error(data.message);
    }
  }

  public async searchZipcode() {
    try {
      const params = {
        postal_code: this.updateClinicForm.postal_code,
      };
      const result = await ApiHelper.getApi('ZipcodeApi').getList(params);
      if (this.isSetPrefectureCity) {
        this.updateForm(
          this.updateClinicForm,
          'prefecture_id',
          result.address1,
        );
        this.updateForm(this.updateClinicForm, 'city_id', result.address2);
        this.updateForm(this.updateClinicForm, 'address', result.address3);
      }
      return true;
    } catch (error) {
      return false;
    }
  }

  public get dataClinic() {
    return ClinicModule.dataClinic;
  }

  public get uuidClinic() {
    return get(this.dataClinic, 'uuid', '');
  }

  public get fetchingClinic() {
    return ClinicModule.fetchingClinic;
  }

  public async created() {
    if (this.currentUser.role === Roles.clinic) {
      this.clinicId = (this.currentUser.clinics[0] || {}).id;
      this.clinicUuid = this.currentUser.uuid;
    }
    this.isLoading = true;
    ClinicModule.getClinicDetail(this.clinicId);
    this.extend('postal_code', {
      validate: (value: string) => {
        if (this.typeValidate === 'click') {
          return this.computedForm.refs.postal_code.flags.valid;
        }
        return this.searchZipcode();
      },
      message: '住所が見つかりません',
    });
    library.add(faCameraRetro);
    library.add(faDownload);
    library.add(faTrashAlt);
    dom.watch();

    try {
      this.listPrefecture = (
        await ApiHelper.getApi('PrefectureApi').listPrefecture()
      ).data;
      this.isLoading = false;
    } catch (error) {
      console.log(error);
    }
  }

  @Watch('dataClinic')
  public watchDataClinic() {
    this.setData(this.updateClinicForm, this.dataClinic);
  }
}
